import apiClient from './api'

const departmentService = {
  async getDepartments(params = {}) {
    try {
      params['_no_pagination_'] = 1
      const response = await apiClient.get('/admin/departments', { params })
      return response.data
    } catch (error) {
      throw error.response?.data || error
    }
  },

  async getDepartment(id) {
    try {
      const response = await apiClient.get(`/admin/departments/${id}`)
      return response.data
    } catch (error) {
      throw error.response?.data || error
    }
  },

  async createDepartment(department) {
    try {
      // Create FormData for file upload
      const formData = new FormData();
      formData.append('rrn', department.rrn);
      formData.append('name', department.name);
      formData.append('internal', department.internal ? 1 : 0);
      formData.append('active', department.active ? 1 : 0);
      
      if (department.parent_id) {
        formData.append('parent_id', department.parent_id);
      }
      
      // Handle send_permissions array
      if (department.send_permissions && Array.isArray(department.send_permissions)) {
        department.send_permissions.forEach(permissionId => {
          formData.append('send_permissions[]', permissionId);
        });
      }
      
      if (department.stamp) {
        formData.append('stamp', department.stamp);
      }

      const response = await apiClient.post('/admin/departments', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error creating department:', error);
      throw error.response?.data || error;
    }
  },

  async updateDepartment(id, department) {
    try {
      // Create FormData for file upload
      const formData = new FormData();
      formData.append('rrn', department.rrn);
      formData.append('name', department.name);
      formData.append('internal', department.internal ? 1 : 0);
      formData.append('active', department.active ? 1 : 0);
      
      if (department.parent_id) {
        formData.append('parent_id', department.parent_id);
      }
      
      // Handle send_permissions array
      if (department.send_permissions && Array.isArray(department.send_permissions)) {
        department.send_permissions.forEach(permissionId => {
          formData.append('send_permissions[]', permissionId);
        });
      }
      
      if (department.stamp) {
        formData.append('stamp', department.stamp);
      }
      formData.append('_method', 'PUT')
      const response = await apiClient.post(`/admin/departments/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error updating department:', error);
      throw error.response?.data || error;
    }
  },

  async deleteDepartment(id) {
    try {
      const response = await apiClient.delete(`/admin/departments/${id}`)
      return response.data
    } catch (error) {
      throw error.response?.data || error
    }
  }
}

export default departmentService 